/** iPadOS 13+ / Chrome 模拟：UA 常为 Macintosh，需结合触控判断 */
const isIPad = () => {
  const ua = navigator.userAgent;
  if (/iPad/i.test(ua)) return true;
  // 真机：platform 为 MacIntel；Chrome Win 模拟：platform 仍是 Win32，只能看 UA
  const macLike =
    /Macintosh/i.test(ua) || navigator.platform === 'MacIntel';
  // 真 Mac 一般为 0；iPad / DevTools 触控模拟为 >= 1（有的环境只有 1）
  return macLike && navigator.maxTouchPoints >= 1;
};

export const isMobile = () => {
  if (isIPad()) return true;
  return !!navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  );
}

export const isHarmonyOS = () => {
  const userAgent = navigator.userAgent;
  return /OpenHarmony/i.test(userAgent);
}

export const isHuaweiOrHonor = () => {
  const ua = navigator.userAgent.toLowerCase();
  // 检测华为或荣耀的关键字
  return /huawei|honor|h60|hi6210|ath-ul06|hol-u19|hw-|h30|che2|chm|hi3660|knt|al10|clt|eva/i.test(ua);
}

export const isAndroid = () => {
  const ua = navigator.userAgent.toLowerCase();
  return ua.indexOf('android') > -1 || ua.indexOf('linux') > -1;
}

export const isIOS = () => {
  const ua = navigator.userAgent.toLowerCase();
  return /iphone|ipod/.test(ua) || isIPad();
}